import styled from '@emotion/styled';

export const TableContainer = styled.div(props => ({
	overflowX: 'auto',
	borderRadius: '12px',
	border: '1px solid #E5E7EA',

	table: {
		borderCollapse: 'collapse',
		width: '100%',
		cursor: 'default',
		position: 'relative',
		margin: '0 auto',
		boxShadow: '0 0 0 5px #E5E7EA',
	},

	thead: {
		th: {
			backgroundColor: '#353E47',
			color: '#fff',
			width: 'auto',
			textAlign: props.theme.direction === 'ltr' ? 'left' : 'right',
			minWidth: 'max-content',
			whiteSpace: 'nowrap',
			padding: '18px 1rem',
			fontWeight: 400,
			fontSize: '16px',
		},
	},

	tbody: {
		tr: {
			backgroundColor: '#fff',
			position: 'relative',
			overflow: 'initial',

			'&:nth-of-type(even)': {
				td: {
					backgroundColor: '#F7F7F7',
					textAlign: props.theme.direction === 'ltr' ? 'left' : 'right',

					'&:first-of-type, &:last-of-type': {
						backgroundColor: '#fff',
					},
				},
			},
		},

		td: {
			width: 'auto',
			padding: '20px 1rem',
			minWidth: 'max-content',
			fontWeight: 300,
			lineHeight: '17px',
			fontSize: '14px',
			verticalAlign: 'top',

			'&:first-of-type': {
				maxWidth: '32px !important',
			},

			'&:last-of-type': {
				maxWidth: '32px',
			},

			'&.center': {
				verticalAlign: 'middle',
			},
		},

		'.semibold': {
			fontWeight: 500,
		},

		'.actions': {
			display: 'flex',
			flexDirection: 'column',
			minWidth: 'max-content',
			fontSize: '14px',
			alignItems: props.theme.direction === 'rtl' ? 'flex-start' : 'flex-end',

			button: {
				cursor: 'pointer',
				fontWeight: 500,
				fontSize: '14px',
			},

			'.bonus': {
				fontWeight: 300,
				color: '#000',
				marginBottom: '6px',
			},
		},
	},
}));
